import React, { useMemo } from "react";
import { useHistory } from "react-router";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { useBooleanState } from "src/hooks/utils";
import { useIsAdmin } from "src/store/login/hooks/useSelectors";
import useTemplates2RolesModal from "../modals/Templates2RolesModal/useTemplates2RolesModal";
import NavItem from "./NavItem";

import { Container } from "./styles";
import { getAdminUrls } from "./utils";

type Props = {
  templateId: number;
};

const AdminShortcutNav = ({ templateId }: Props) => {
  const [toggled, setToggled] = useBooleanState(false);

  const formatMsg = useFormatMsg();
  const { push } = useHistory();
  const isAdmin = useIsAdmin();
  const { templates2RolesModal, toggleTemplates2RolesModal } =
    useTemplates2RolesModal(templateId);

  const { settings, data, presentation } = useMemo(
    () => getAdminUrls(templateId),
    [templateId]
  );

  if (!isAdmin) return null;

  return (
    <Container toggled={toggled}>
      <NavItem
        iconName="settings"
        tooltip={formatMsg("administration.nav.template_builder", {
          templateId,
        })}
        onClick={setToggled}
      />
      <NavItem
        iconName="build"
        tooltip={formatMsg("administration.nav.settings")}
        linkTo={settings}
      />

      <NavItem
        iconName="layers"
        tooltip={formatMsg("administration.nav.data_model")}
        linkTo={data}
      />
      <NavItem
        iconName="tablet"
        tooltip={formatMsg("administration.nav.presentation_model")}
        linkTo={presentation}
      />
      <NavItem
        iconName="compare_arrows"
        tooltip={formatMsg("roles.add_roles")}
        onClick={toggleTemplates2RolesModal}
      />
      {templates2RolesModal}
    </Container>
  );
};

export default AdminShortcutNav;
